import API from '../../../constants/api';

export const FETCH_BLOCK_LIST_REQUEST = '@@block/FETCH_BLOCK_LIST_REQUEST';
export const FETCH_BLOCK_LIST_SUCCESS = '@@block/FETCH_BLOCK_LIST_SUCCESS';
export const FETCH_BLOCK_LIST_FAILURE = '@@block/FETCH_BLOCK_LIST_FAILURE';

export const CREATE_BLOCK_REQUEST = '@@block/CREATE_BLOCK_REQUEST';
export const CREATE_BLOCK_SUCCESS = '@@block/CREATE_BLOCK_SUCCESS';
export const CREATE_BLOCK_FAILURE = '@@block/CREATE_BLOCK_FAILURE';

export const CLEAR_BLOCK_STATE = '@@block/CLEAR_BLOCK_STATE';

export const fetchPagesOfBlock = (
    api = API.SERVICES.PAGES,
    page,
    size,
    sortCol,
    sortOrder,
    filters,
) => ({
    type: FETCH_BLOCK_LIST_REQUEST,
    api: `${api}?page=${page}&size=${size}&sortCol=${sortCol}&sortOrder=${sortOrder}&filter=${encodeURIComponent(JSON.stringify(filters))}`,
    page,
    size,
});

export const createBlockRequest = (block, isUpdate, successCallback, failureCallBack) => ({
    type: CREATE_BLOCK_REQUEST,
    api: API.SBS.BLOCK.PAGES,
    block,
    isUpdate,
    successCallback,
    failureCallBack,
});

export const clearBlockState = () => ({
    type: CLEAR_BLOCK_STATE,
});
